document.addEventListener('DOMContentLoaded', () => {
    const loadMoreBtn = document.getElementById('loadMoreGameEvents');
    const eventsContainer = document.getElementById('gameEventsContainer');
    const paginationDataEl = document.getElementById('gameEventsPaginationData');

    if (loadMoreBtn && eventsContainer && paginationDataEl) {
        initLoadMoreGameEvents();
    }
});

function initLoadMoreGameEvents() {
    const btn = document.getElementById('loadMoreGameEvents');
    const container = document.getElementById('gameEventsContainer');
    const paginationData = document.getElementById('gameEventsPaginationData');

    if (!btn || !container || !paginationData) return;

    // Remove existing listeners by cloning
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    newBtn.addEventListener('click', () => {
        const nextPage = paginationData.dataset.nextPage;
        if (!nextPage) return;

        newBtn.disabled = true;
        const originalText = newBtn.textContent;
        newBtn.textContent = `${originalText}...`;

        const url = new URL(window.location.href);
        url.searchParams.set('page', nextPage);

        fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                // Select direct children of the container
                const newItems = doc.querySelectorAll('#gameEventsContainer > *');

                newItems.forEach((node) => {
                    container.appendChild(node);

                    // Initialize lightGallery for new items if needed
                    if (window.jQuery && window.jQuery.fn.lightGallery) {
                        const $node = window.jQuery(node);
                        const $gallery = $node.find('.video-gallery');

                        $gallery.each(function () {
                            const $this = window.jQuery(this);
                            const dataSrc = $this.find('span').attr('data-src');
                            let time = 1;

                            // Extract time param manually or use global getParams if available
                            if (typeof getParams === 'function') {
                                time = getParams(dataSrc)['t'] || 1;
                            } else {
                                try {
                                    const url = new URL(dataSrc);
                                    time = url.searchParams.get('t') || 1;
                                } catch (e) {
                                    console.warn('Could not parse video URL:', dataSrc);
                                }
                            }

                            $this.lightGallery({
                                selector: 'span',
                                loadYoutubeThumbnail: true,
                                youtubeThumbSize: 'default',
                                loadVimeoThumbnail: true,
                                vimeoThumbSize: 'thumbnail_medium',
                                youtubePlayerParams: {
                                    autoplay: 1,
                                    start: time,
                                    end: parseInt(time) + 30,
                                }
                            });
                        });
                    }
                });

                const newPaginationData = doc.getElementById('gameEventsPaginationData');
                if (newPaginationData && newPaginationData.dataset.nextPage) {
                    paginationData.dataset.nextPage = newPaginationData.dataset.nextPage;
                } else if (newBtn.parentNode) {
                    // No more pages, remove the button container (parent is col-12)
                    // The structure is row -> col-12 -> button
                    // We want to remove the row? Or just the button?
                    // _game_events.html.erb:
                    // <div class="row">
                    //   <div class="col-12 ...">
                    //     <button ...>
                    //   </div>
                    // </div>
                    // Let's remove the button's closest row if it's the only thing in it, or just the button.
                    // Safest is to remove the button.
                    newBtn.parentNode.removeChild(newBtn);
                }
            })
            .catch((error) => {
                console.error('Error loading more game events:', error);
                if (window.showNotification) {
                    const msg = (newBtn.dataset && newBtn.dataset.errorText) || 'Failed to load more events.';
                    window.showNotification(msg, 'error');
                }
            })
            .finally(() => {
                // If button still exists (meaning there are more pages), reset it
                if (document.body.contains(newBtn)) {
                    newBtn.disabled = false;
                    newBtn.textContent = originalText;
                }
            });
    });
}
